export default {"src":"/_next/static/media/icon_14.8bb8e3b5.svg","height":34,"width":34};